import type { RefObject } from 'react';
import { useRef } from 'react';

/**
 * The latest `value`, for code that React does not run: a callback of a long-lived object, a
 * timer, a draw loop. It is a ref that holds data, so it is a rare case: each call must meet the
 * three conditions of *Refs and imperative DOM* in docs/rules/react_architecture.md.
 */
export function useLatest<T>(value: T): RefObject<T> {
    const ref = useRef(value);
    // The timeline calls functions of useTimelineRange in its render, and these functions read
    // the refs.
    // eslint-disable-next-line react-hooks/refs -- the timeline reads these refs in its render
    ref.current = value;
    return ref;
}
